module.exports = __webpack_public_path__ + "static/img/9一种适用于不同管径管子的弯管机.4e8b4c0b.jpg";